const React = require("react");

function MinusSmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 12H6"
  }));
}

module.exports = MinusSmIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MinusSmIcon.js
 ** module id = 569
 ** module chunks = 0
 **/